import { useEffect, useState } from 'react';

import { Card, Table, TableBody, TableContainer, Box, TablePagination } from '@mui/material';

import useTable from '../../../hooks/useTable';
import { TableHeadCustom, TableNoData } from '../../../components/table';
import Scrollbar from '../../../components/Scrollbar';
import SkeletonTable from '../../../components/skeleton/SkeletonTable';
import DuelLeaderboadrTableRow from './DuelLeaderboardTableRow';
import { networkGetDuelLeaderboardList } from 'src/network/duels';
import { DUEL_LEADERBOARD_TABLE_HEAD } from 'src/constants/tableHeads';

// ----------------------------------------------------------------------

export default function DuelLeaderboard({ selectedDuelId }) {
  const { dense, page, order, orderBy, rowsPerPage, setPage, selected, onSort, onChangePage, onChangeRowsPerPage } = useTable();

  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [fetchedPages, setFetchedPages] = useState([]);

  const isNotFound = tableData.length === 0;

  const onGetLeaderboardList = (pageIndex = 0) => {
    if (fetchedPages?.includes(pageIndex)) return;

    setIsLoading(true);
    networkGetDuelLeaderboardList(selectedDuelId, pageIndex)
      .then((res) => {
        const duelList = res.data.items || [];
        setTableData([...tableData, ...duelList]);
        setFetchedPages([...fetchedPages, pageIndex]);
        setPage(pageIndex);
      })
      .catch((error) => console.log(error))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    onGetLeaderboardList(page);
  }, [page]);

  return (
    <Card>
      {/* <FeedItemTableToolbar filterName={filterName} onFilterName={handleFilterName} /> */}
      <Scrollbar>
        <TableContainer sx={{ position: 'relative' }}>
          <Table size={dense ? 'small' : 'medium'}>
            <TableHeadCustom
              order={order}
              orderBy={orderBy}
              headLabel={DUEL_LEADERBOARD_TABLE_HEAD}
              rowCount={tableData.length}
              numSelected={selected.length}
              onSort={onSort}
            />
            <TableBody>
              {isLoading ? (
                [...Array(7)]?.map((_, index) => <SkeletonTable key={index} numOfColumns={DUEL_LEADERBOARD_TABLE_HEAD.length} />)
              ) : tableData.length ? (
                tableData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, index) => <DuelLeaderboadrTableRow key={row.GameID} row={row} rowNumber={page * rowsPerPage + index + 1} />)
              ) : (
                <TableNoData isNotFound={isNotFound} />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>

      <Box sx={{ position: 'relative' }}>
        {!isLoading && tableData?.length > 0 ? (
          <TablePagination
            rowsPerPageOptions={[50]}
            component="div"
            count={tableData?.length !== (page + 1) * 50 ? tableData?.length : tableData?.length + 1}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={onChangePage}
            onRowsPerPageChange={onChangeRowsPerPage}
          />
        ) : null}
      </Box>
    </Card>
  );
}
